export const SET_CARREGANDO_APLICACAO = 'SET_CARREGANDO_APLICACAO';

export const ROT_SET_ROTAS_MENUS_SUCCESS = 'ROT_SET_ROTAS_MENUS_SUCCESS';
export const ROT_SET_ROTAS_MENUS_FAIL = 'ROT_SET_ROTAS_MENUS_FAIL';

export const USR_SET_PESSOA_LOGADA_SUCCESS = 'USR_SET_PESSOA_LOGADA_SUCCESS';
export const USR_SET_PESSOA_LOGADA_FAIL = 'USR_SET_PESSOA_LOGADA_FAIL';
export const USR_SET_PESSOA_SUCCESS = 'USR_SET_PESSOA_SUCCESS';
export const USR_SET_PESSOA_FAIL = 'USR_SET_PESSOA_FAIL';
export const USR_CONFIGURACAO_NOTIFICACAO_SUCESSO = 'USR_CONFIGURACAO_NOTIFICACAO_SUCESSO';
export const USR_CONFIGURACAO_NOTIFICACAO_FALHA = 'USR_CONFIGURACAO_NOTIFICACAO_FALHA';

export const EMP_SET_EMPRESA_SUCCESS = 'EMP_SET_EMPRESA_SUCCESS';
export const EMP_SET_EMPRESA_FAIL = 'EMP_SET_EMPRESA_FAIL';
export const EMP_SET_EMPRESAS_SUCCESS = 'EMP_SET_EMPRESAS_SUCCESS';
export const EMP_FETCH_EMPRESAS_SC_ENTRADA_SUCCESS = "EMP_FETCH_EMPRESAS_SC_ENTRADA_SUCCESS"
export const EMP_SET_EMPRESAS_FAIL = 'EMP_SET_EMPRESAS_FAIL';
export const EMP_REPLICAR_CREDENCIAIS_SUCCESS = 'EMP_REPLICAR_CREDENCIAIS_SUCCESS';
export const EMP_REPLICAR_CREDENCIAIS_FAIL = 'EMP_REPLICAR_CREDENCIAIS_FAIL';
export const EMP_FETCH_EMPRESAS_MT_SUCCESS = 'EMP_FETCH_EMPRESAS_MT_SUCCESS';
export const EMP_FETCH_EMPRESAS_MT_FAIL = 'EMP_FETCH_EMPRESAS_MT_FAIL';
export const EMP_FETCH_EMPRESAS_GO_ENTRADA_SUCCESS = 'EMP_FETCH_EMPRESAS_GO_ENTRADA_SUCCESS';
export const EMP_FETCH_EMPRESAS_GO_ENTRADA_FAIL = 'EMP_FETCH_EMPRESAS_GO_ENTRADA_FAIL';
export const EMP_FETCH_EMPRESAS_GO_SUCCESS = 'EMP_FETCH_EMPRESAS_GO_SUCCESS';
export const EMP_FETCH_EMPRESAS_GO_FAIL = 'EMP_FETCH_EMPRESAS_GO_FAIL';

export const ENM_SET_TIPOS_ACESSO_SUCCESS = 'ENM_SET_TIPOS_ACESSO_SUCCESS';
export const ENM_SET_TIPOS_ACESSO_FAIL = 'ENM_SET_TIPOS_ACESSO_FAIL';
export const ENM_SET_TIPOS_DOCUMENTO_FISCAL_SUCCESS = 'ENM_SET_TIPOS_DOCUMENTO_FISCAL_SUCCESS';
export const ENM_SET_TIPOS_DOCUMENTO_FISCAL_FAIL = 'ENM_SET_TIPOS_DOCUMENTO_FISCAL_FAIL';
export const ENM_SET_ORIGENS_DOCUMENTO_FISCAL_SUCCESS = 'ENM_SET_ORIGENS_DOCUMENTO_FISCAL_SUCCESS';
export const ENM_SET_ORIGENS_DOCUMENTO_FISCAL_FAIL = 'ENM_SET_ORIGENS_DOCUMENTO_FISCAL_FAIL';
export const EMN_SET_CST_ICMS_SUCCESS = 'EMN_SET_CST_ICMS_SUCCESS';
export const ENM_SET_SITUACAO_MANIFESTO_SUCCESS = 'ENM_SET_SITUACAO_MANIFESTO_SUCCESS';
export const ENM_SET_SITUACAO_MANIFESTO_FAIL = 'ENM_SET_SITUACAO_MANIFESTO_FAIL';
export const ENM_SET_SITUACAO_XML_MANIFESTO_SUCCESS = 'ENM_SET_SITUACAO_XML_MANIFESTO_SUCCESS';
export const ENM_SET_SITUACAO_XML_MANIFESTO_FAIL = 'ENM_SET_SITUACAO_XML_MANIFESTO_FAIL';
export const ENM_SET_UNIDADES_FEDERATIVAS_SUCCESS = 'ENM_SET_UNIDADES_FEDERATIVAS_SUCCESS';
export const ENM_SET_UNIDADES_FEDERATIVAS_FAIL = 'ENM_SET_UNIDADES_FEDERATIVAS_FAIL';
export const ENM_SET_TIPO_DOCUMENTO_CONSULTA_SUCCESS = 'ENM_SET_TIPO_DOCUMENTO_CONSULTA_SUCCESS';
export const ENM_SET_TIPO_DOCUMENTO_CONSULTA_FAIL = 'ENM_SET_TIPO_DOCUMENTO_CONSULTA_FAIL';
export const ENM_SET_TIPO_CONSULTA_SUCCESS = 'ENM_SET_TIPO_CONSULTA_SUCCESS';
export const ENM_SET_TIPO_CONSULTA_FAIL = 'ENM_SET_TIPO_CONSULTA_FAIL';
export const ENM_SET_CIDADES_SUCCESS = 'ENM_SET_CIDADES_SUCCESS';
export const ENM_SET_CIDADES_FAIL = 'ENM_SET_CIDADES_FAIL';
export const ENM_SET_METODOS_BUSCA_SUCCESS = 'ENM_SET_METODOS_BUSCA_SUCCESS';
export const ENM_SET_METODOS_BUSCA_FAIL = 'ENM_SET_METODOS_BUSCA_FAIL';
export const ENM_SET_ESTRUTURA_DOWNLOAD_SUCCESS = 'ENM_SET_ESTRUTURA_DOWNLOAD_SUCCESS';
export const ENM_SET_ESTRUTURA_DOWNLOAD_FAIL = 'ENM_SET_ESTRUTURA_DOWNLOAD_FAIL';
export const ENM_SET_PORTAL_ESTADUAL_SUCCESS = 'ENM_SET_PORTAL_ESTADUAL_SUCCESS';
export const ENM_SET_PORTAL_ESTADUAL_FAIL = 'ENM_SET_PORTAL_ESTADUAL_FAIL';

export const DOCFIS_SET_DOCUMENTOS_FISCAIS_SUCCESS = 'DOCFIS_SET_DOCUMENTOS_FISCAIS_SUCCESS';
export const DOCFIS_SET_DOCUMENTOS_FISCAIS_FAIL = 'DOCFIS_SET_DOCUMENTOS_FISCAIS_FAIL';
export const DOCFIS_SET_NOTA_FISCAL_SUCCESS = 'DOCFIS_SET_NOTA_FISCAL_SUCCESS';
export const DOCFIS_SET_DOCUMENTO_FISCAL_FAIL = 'DOCFIS_SET_DOCUMENTO_FISCAL_FAIL';
export const DOCFIS_SET_DOWNLOAD_DOCUMENTOS_FISCAIS_SUCCESS =
  'DOCFIS_SET_DOWNLOAD_DOCUMENTOS_FISCAIS_SUCCESS';
export const DOCFIS_SET_DOWNLOAD_DOCUMENTOS_FISCAIS_FAIL =
  'DOCFIS_SET_DOWNLOAD_DOCUMENTOS_FISCAIS_FAIL';
export const DOCFIS_SET_DELETE_FAIL = 'DOCFIS_SET_DELETE_FAIL';
export const DOCFIS_SET_EXTRACT_SUCCESS = 'DOCFIS_SET_EXTRACT_SUCCESS';
export const DOCFIS_SET_EXTRACT_FAIL = 'DOCFIS_SET_EXTRACT_FAIL';
export const DOCFIS_SET_BUSCAR_DOCUMENTO_SUCCESS = 'DOCFIS_SET_BUSCAR_DOCUMENTO_SUCCESS';
export const DOCFIS_SET_BUSCAR_DOCUMENTO_FAIL = 'DOCFIS_SET_BUSCAR_DOCUMENTO_FAIL';

export const MAN_SET_MANIFESTOS_SUCCESS = 'MAN_SET_MANIFESTOS_SUCCESS';
export const MAN_SET_MANIFESTOS_FAIL = 'MAN_SET_MANIFESTOS_FAIL';
export const MAN_SET_MANIFESTAR_SUCCESS = 'MAN_SET_MANIFESTAR_SUCCESS';
export const MAN_SET_MANIFESTAR_FAIL = 'MAN_SET_MANIFESTAR_FAIL';

export const DASH_SET_DOCUMENTOS_FISCAIS_SUCCESS = 'DASH_SET_DOCUMENTOS_FISCAIS_SUCCESS';
export const DASH_SET_DOCUMENTOS_FISCAIS_FAIL = 'DASH_SET_DOCUMENTOS_FISCAIS_FAIL';
export const DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_SUCCESS =
  'DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_SUCCESS';
export const DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_FAIL = 'DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_FAIL';
export const DASH_SET_ULTIMA_SEMANA_SUCCESS = 'DASH_SET_ULTIMA_SEMANA_SUCCESS';
export const DASH_SET_ULTIMA_SEMANA_FAIL = 'DASH_SET_ULTIMA_SEMANA_FAIL';
export const DASH_SET_ULTIMA_CONSULTA_SUCCESS = 'DASH_SET_ULTIMA_CONSULTA_SUCCESS';
export const DASH_SET_ULTIMA_CONSULTA_FAIL = 'DASH_SET_ULTIMA_CONSULTA_FAIL';
export const DASH_SET_SEM_MANIFESTO_SUCCESS = 'DASH_SET_SEM_MANIFESTO_SUCCESS';
export const DASH_SET_SEM_MANIFESTO_FAIL = 'DASH_SET_SEM_MANIFESTO_FAIL';
export const DASH_SET_ESTADO_INICIAL = 'DASH_SET_ESTADO_INICIAL';
export const DASH_SET_NOTIFICATIONS = 'DASH_SET_NOTIFICATIONS';
export const HISCON_SET_HISTORICO_SUCCESS = 'HISCON_SET_HISTORICO_SUCCESS';
export const HISCON_SET_HISTORICO_FAIL = 'HISCON_SET_HISTORICO_FAIL';
export const HISCON_SET_HISTORICO_PORTAL_ESTADUAL_SUCCESS =
  'HISCON_SET_HISTORICO_PORTAL_ESTADUAL_SUCCESS';
export const HISCON_SET_HISTORICO_PORTAL_ESTADUAL_FAIL =
  'HISCON_SET_HISTORICO_PORTAL_ESTADUAL_FAIL';

export const NOT_TOTAL_NOTIFICACAO_NAO_LIDA = 'NOT_TOTAL_NOTIFICACAO_NAO_LIDA';
export const NOT_MARCAR_TODAS_NOTIFICOES_LIDAS = 'NOT_MARCAR_TODAS_NOTIFICOES_LIDAS';
export const NOT_ADICIONA_NOTIFICACAO_SUCCESS = 'NOT_ADICIONA_NOTIFICACAO_SUCCESS';
export const NOT_NOTIFICACOES_SUCCESS = 'NOT_NOTIFICACOES_SUCCESS';
export const NOT_NOTIFICACOES_FAIL = 'NOT_NOTIFICACOES_FAIL';
export const NOT_REGISTRA_NOTIFICACAO_FAIL = 'NOT_REGISTRA_NOTIFICACAO_FAIL';
export const NOT_REGISTRA_NOTIFICACAO_SUCCESS = 'NOT_REGISTRA_NOTIFICACAO_SUCCESS';
export const NOT_ATUALIZA_NOTIFICACOES_SUCCESS = 'NOT_ATUALIZA_NOTIFICACOES_SUCCESS';
export const NOT_MARCAR_NOTIFICACAO_LIDO_SUCCESS = 'NOT_MARCAR_NOTIFICACAO_LIDO_SUCCESS';
export const NOT_MARCAR_NOTIFICACAO_LIDO_FAIL = 'NOT_MARCAR_NOTIFICACAO_LIDO_FAIL';

export const FILA_CHAVES_SET_CHAVES_SUCCESS = 'FILA_CHAVES_SET_CHAVES_SUCCESS';
export const FILA_CHAVES_SET_CHAVES_FAIL = 'FILA_CHAVES_SET_CHAVES_FAIL';